import { render, staticRenderFns } from "./Memberships.vue?vue&type=template&id=688427db&scoped=true"
import script from "./Memberships.vue?vue&type=script&lang=js"
export * from "./Memberships.vue?vue&type=script&lang=js"
import style0 from "./Memberships.vue?vue&type=style&index=0&id=688427db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688427db",
  null
  
)

export default component.exports